<p-dialog
  *ngIf="showResumeFileDialog"
  [visible]="showResumeFileDialog"
  (visibleChange)="onFlag('showResumeFileDialog', $event)"
  [dismissableMask]="true"
  [draggable]="false"
  [modal]="true"
  [resizable]="false"
  styleClass="resume-dialog"
  [style]="{
    width: '90%',
    maxWidth: isTablet ? '80%' : 'unset',
    height: '90%'
  }"
  [appendTo]="isSearch ? 'body' : null"
  header="Resume Preview">
  <div class="resume-content-wrapper">
    <div class="resume-toolbar" *ngIf="currentPitchCard?.resumeFileUrl">
      <a
        (click)="downloadResume($event)"
        [href]="currentPitchCard.resumeFileUrl"
        class="download-resume-btn">
        <img
          alt="Download"
          src="/assets/images/pitch-card-svg/download-icon.svg"
          class="download-btn-icon" />
        <span class="download-btn-label">Download Resume</span>
      </a>
    </div>

    <ngx-doc-viewer
      *ngIf="showViaDocViewer()"
      [url]="currentPitchCard.resumeFileUrl"
      class="resume-modal resume-viewer"
      [googleCheckContentLoaded]="true"
      [googleCheckInterval]="3000"
      viewerUrl="https://docs.google.com/gview?url=%URL%&embedded=true"></ngx-doc-viewer>

    <div
      *ngIf="!showViaDocViewer() && currentPitchCard.resumeFileUrl"
      class="image-resume-preview">
      <img [src]="currentPitchCard.resumeFileUrl" alt="resume image" />
    </div>

    <div
      *ngIf="!showViaDocViewer() && !currentPitchCard?.resumeFileUrl"
      class="resume-unavailable">
      <h2>Resume Unavailable</h2>
    </div>
  </div>
</p-dialog>
